module.exports = __webpack_public_path__ + "img/electrify-america-solar-glow-1.2d4c23c5.webp";